export const SECURITY_ICONS_ID = 'shop-header-security-icons-box';
export const SHIPPING_FEE_TEXT_ID = 'shop-header-shipping-fee-text';
export const BURGER_PANEL_PORTAL = 'burger-panel-portal-container';

export const AUTH_READY = 'AUTH-READY-v1';
export const AUTH_SUCCESS_EVENT = 'AUTH-SUCCESS-EVENT-v1';
export const AUTH_FAILURE_EVENT = 'AUTH-FAILURE-EVENT-v1';
export const AUTH_LOGOUT_EVENT = 'AUTH-LOGOUT-EVENT-v1';
export const GET_CART_EVENT = 'GET-CART-SUCCESS-v1';
export const ADD_TO_CART_EVENT = 'ADD-TO-CART-SUCCESS-v1';
export const THEME_CLASSNAME_MAP = {
    zooplus: 'z-brand-theme-2026spring-zooplus',
    bitiba: 'z-brand-theme-2026spring-bitiba',
};
